import { QRCodeSVG } from 'qrcode.react';
import React from 'react';
import type { ReactNode } from 'react';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, QRCodeWrapper, CopyInput } from '@woovi/ui';

import type { PaymentLinkActiveQrCode_charge$key } from './__generated__/PaymentLinkActiveQrCode_charge.graphql.ts';
import { useChargePaymentMethod } from '../../../charge/useChargePaymentMethod.tsx';

type PaymentLinkActiveQrCodeProps = {
  charge: PaymentLinkActiveQrCode_charge$key;
  qrCodeShow: boolean;
  setQrCodeShow: (value: boolean) => unknown;
  copyQRCodeError: boolean;
  alwaysShowQrCode?: boolean;
};
const PaymentLinkActiveQrCode = ({
  alwaysShowQrCode = false,
  ...props
}: PaymentLinkActiveQrCodeProps): ReactNode | null => {
  const charge = useFragment<PaymentLinkActiveQrCode_charge$key>(
    graphql`
      fragment PaymentLinkActiveQrCode_charge on Charge {
        paymentMethods {
          ... on PaymentMethodPix {
            method
            brCode
          }
        }
        ...useChargePaymentMethod_charge
      }
    `,
    props.charge,
  );

  const { pix, pixCob } = useChargePaymentMethod(charge);

  const qrCodeShow =
    props.qrCodeShow || props.copyQRCodeError || alwaysShowQrCode;

  const hasPix = pix && pix.brCode;
  const hasPixCob = pixCob && pixCob.brCode;

  if (!hasPix && !hasPixCob) {
    return null;
  }

  const brCode = hasPixCob ? pixCob.brCode : pix.brCode;

  return (
    <>
      <QRCodeWrapper qrCodeShow={qrCodeShow} data-testid='qrcode'>
        <QRCodeSVG value={brCode} marginSize={4} />
      </QRCodeWrapper>
      <BoxFlex
        sx={{
          '@media (min-width: 600px)': {
            display: 'none',
          },
        }}
      >
        <CopyInput
          value={brCode}
          error={props.copyQRCodeError}
          onError={(error) => props.setQrCodeShow(!error)}
        />
      </BoxFlex>
    </>
  );
};

export default PaymentLinkActiveQrCode;
